export const punchcardKeys = {
  all: ['punchcard'] as const,
  collects: (agreementUuid: string) =>
    [...punchcardKeys.all, 'collects', agreementUuid] as const,
  agreementInfo: (agreementUuid: string) =>
    [...punchcardKeys.all, 'agreementInfo', agreementUuid] as const,
} as const;
